import axios from 'axios';
import { apiUrl } from '../config/config.js';

// Base URL for the backend API
const BASE_URL = apiUrl;

// Create axios instance with default config
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Login function
export const login = async (credentials) => {
    console.log(credentials)
    try {
        const response = await api.post('admin/login', credentials);
        
        // If login is successful, store the token
        if (response.data.token) {
            localStorage.setItem('adminToken', response.data.token);
            // Set the token in axios default headers for subsequent requests
            api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        }
        
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
};

// Logout function
export const logout = () => {
    localStorage.removeItem('adminToken');
    delete api.defaults.headers.common['Authorization'];
};

// Check if user is authenticated
export const isAuthenticated = () => {
    return !!localStorage.getItem('adminToken');
};

// Get current authentication token
export const getToken = () => {
    return localStorage.getItem('adminToken');
};

// Set up axios interceptor to add token to requests
api.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Set up axios interceptor to handle token expiration
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            logout(); // Clear invalid token
            window.location.href = '/login'; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default api;
